import {BasicEntity} from '../../../../allkey/framework/message/BasicEntity';

export class ConnectBasicEntityExt extends BasicEntity {
code: string;
}

